// extracted by mini-css-extract-plugin
export default {"defaultStyles":"defaultStyles___bqbhx"};